<template>
  <div
    class="modal fade"
    id="exampleModal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalLabel"
    aria-hidden="true"
  >
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLabel">Terms & Conditions</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <small>
            '6 MONTH NETFLIX' Promotion commences on the 15th June 2020 and concludes on the 31st July 2020. 6 months free claim based on Netflix service plan of $9.99/month for a single
standard definition stream. Higher priced subscription services will lessen this period. Maximum 1 claim per installation address. This promotion is only available to 'Eligible Purchasers',
which are defined as Australian Hot Water customers. Any purchase and installation of 1 (one) Dux Proflo electric storage, Prodigy 4 gas storage, Prodigy 5 gas storage, Always Hot
Continuous Flow, Ecosmart solar system, Airoheat, thereby creating an 'Eligible Purchase', will be awarded in accordance with these conditions, one (1) Netflix voucher valued at $60.
Claim must be received by Dux by 10th August 2020. Claims to be submitted online via www.dux.com.au/netflix and proof of purchase must be submitted with claim to be eligible. Allow
2 weeks for claims to be processed. Vouchers will be emailed to the email address submitted in the claim form. None of the prizes in the '6 MONTH NETFLIX' are transferable, redeemable
for cash or can be used in conjunction with any other promotional offer or tank rebate. Dux reserves the right to switch the prize if unavailable for an alternate prize of equal or greater
value. The 'Promoter' is Dux Manufacturing Limited (ABN 19 077 879 844) "Dux", Lackey Road, Moss Vale NSW 2577. DUX is a registered trade marks of Dux Manufacturing Limited. All
other trade marks appearing in this promotion are the property of their respective trade mark owners.
          </small>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'TermsModal'
}
</script>
